import React, { useState, useEffect } from 'react';
import { Toast as BSToast, ToastContainer } from 'react-bootstrap';

const Toast = ({ show, message, onClose, variant = 'danger' }) => {
  const [showToast, setShowToast] = useState(show);

  useEffect(() => {
    setShowToast(show);
  }, [show]);

  const handleClose = () => {
    setShowToast(false);
    if (onClose) {
      onClose();
    }
  };

  return (
    <ToastContainer position="top-end" className="p-3" style={{ zIndex: 9999 }}>
      <BSToast
        show={showToast}
        onClose={handleClose}
        delay={5000}
        autohide
        bg={variant}
      >
        <BSToast.Header>
          <strong className="me-auto">Erro</strong>
        </BSToast.Header>
        <BSToast.Body className="text-white">{message}</BSToast.Body>
      </BSToast>
    </ToastContainer>
  );
};

export default Toast;




